import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/App';

// Editable texts of a public page (managed in admin > Toutes les pages)
export const useSiteSection = (section) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API}/site-content/${section}`).then(r => setData(r.data?.data || {})).catch(() => setData({}));
  }, [section]);
  return data;
};
